const SETLOGGEDSTATUS = (state, status) => {
  state.is_logged = status
}

export default {
  SETLOGGEDSTATUS
}
